import { useEffect, useRef, useState } from 'react';
import Player from '@vimeo/player';

interface VimeoSdkProps {
  videoId: string;
}

const VimeoSdk: React.FC<VimeoSdkProps> = ({ videoId }) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);


  return (
    <div className="border rounded-lg">
      <iframe
        ref={iframeRef}
        src={`https://player.vimeo.com/video/${videoId}`}
        allow="autoplay; fullscreen"
        allowFullScreen
        className="w-full aspect-video rounded"
      />
    </div>
  );
};

export default VimeoSdk;
